declare global {
  /* eslint-disable-next-line no-var */
  var env: any;
}

window.env = window.env || {};

export const environment = {
  production: true,

  apiUrl: window.env.apiUrl || '/api',
  appVersion: window.env.appVersion || 'version_not_set',
  bugsnagApiKey: window.env.bugsnagApiKey || 'api_key_not_set',
  cluster: window.env.cluster || 'cluster_not_set',
  region: window.env.region || 'region_not_set',
  releaseStage: window.env.releaseStage || 'env_not_set',
  releaseVersion: window.env.releaseVersion || 'release_not_set',

  // ZIA/ZPA versions
  configVersion: window.env.configVersion || {
    zia: 'zia0',
    zpa: 'zpa0',
  },

  // Feature flags
  flags: window.env.flags || {},
};
